import { render } from "./PlpNoResults.vue?vue&type=template&id=48cac384"
import script from "./PlpNoResults.vue?vue&type=script&lang=js"
export * from "./PlpNoResults.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__